<template>
  <div>
    <div class="row text-white" style="padding-top: 50px;">
      <div class="col-12 offset-sm-1 col-sm-10 ">
        <h1 class="h1 thai-font mt-4" style="font-weight: 600;">ลงทะเบียนงาน</h1>
        <h3 class="h3 thai-font mb-4" style="font-weight: 600;">
          KMUTT-Engineering Job Fair 2022
        </h3>
      </div>
    </div>
    <div class="row text-white">
      <div class="col-12 offset-sm-1 col-sm-10 ">
        <p class="thai-font" style="font-size: 18px;font-weight: 400;">
          แบบฟอร์มลงทะเบียนเข้าร่วมงาน KMUTT-Engineering Job Fair 2022 <br/>
          ของคณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี <br/>
          วันจันทร์ที่ 21 – วันอังคารที่ 22 มีนาคม 2565
        </p>
      </div>
    </div>
    <template v-if="page === `company`">
      <div class="row text-center">
        <hr class="col-10"/>
      </div>
      <div class="row">
        <!-- progressbar -->
        <div class="md-stepper-horizontal orange thai-font">
          <template v-for="(step, stepId) in steps">
            <div
              @click="$attrs.changeStep(stepForm, stepId)"
              :class="stepId === stepForm ? `md-step active` : `md-step`"
              :key="`Step id ${stepId}`"
            >
              <div class="md-step-circle"><span></span></div>
              <div class="md-step-title">
                {{ step.title }}
                <template v-if="step.subtitle !== ``"
                ><br/>{{ step.subtitle }}
                </template
                >
              </div>
              <div class="md-step-bar-left"></div>
              <div class="md-step-bar-right"></div>
            </div>
          </template>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
    export default {
        name: "registerHead",
        props: {
            page: String,
            steps: Array,
            stepForm: Number
        }
    }
</script>

<style scoped>

</style>
